import styled from 'styled-components';

const Wrapper = styled.div`
${props =>`
  position: relative;
  min-width: ${props.minWidth ? props.minWidth : '220px'};
  @media only screen and (max-width: 1024px) {
    width: 40px;
    height: 40px;
  }
`}`;

export default Wrapper;